<!-- Lookup Panel -->
@if (isOpen()) {
  <!-- Click-away backdrop (transparent so the page stays readable) -->
  <div class="fixed inset-0 z-40" (click)="close()" aria-hidden="true"></div>

  <div
    class="fixed z-40 flex flex-col rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800
           bottom-[10px] right-[10px] w-[calc(100%-20px)] h-[75vh]
           md:w-[560px] md:h-auto md:top-[82px] md:bottom-[10px]"
    role="dialog"
    aria-label="Lookup"
  >
    <!-- Header -->
    <div class="flex flex-none items-center justify-between px-3 h-10 rounded-t-lg bg-black text-white">
      <div class="flex items-center space-x-2 min-w-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
        <span class="text-sm font-medium truncate">Lookup</span>
        <span class="text-xs text-gray-300 truncate">· venues &amp; users</span>
      </div>
      <button
        (click)="close()"
        class="flex items-center justify-center h-6 w-6 rounded hover:bg-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500"
        aria-label="Close lookup"
        title="Close"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body: the Lookup tool in its compact, single-column layout -->
    <div class="flex-1 min-h-0 overflow-y-auto bg-gray-50 dark:bg-gray-900 rounded-b-lg">
      <app-lookup [compact]="true"></app-lookup>
    </div>
  </div>
}

<!-- Floating Lookup Button (sits above the support-assistant bubble) -->
@if (!isOpen()) {
  <button
    (click)="toggle()"
    class="fixed bottom-24 right-6 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-white text-black border-2 border-black shadow-lg transition-all duration-200 hover:bg-gray-100 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
    aria-label="Open lookup"
    title="Lookup venues & users"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
    </svg>
  </button>
}
